import { Route, Navigate } from "react-router-dom";
import PartnerLogin from "@/pages/PartnerLogin";
import ResetPassword from "@/pages/ResetPassword";

// Shared authentication entry points (partner login + password reset). Top-level routes (no Layout
// wrapper), imported by internal + adviser. Public (no auth) omits these. These are neutral — no
// proprietary-research symbols.
export function authRoutes() {
  return (
    <>
      <Route path="/partner/login" element={<PartnerLogin />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/staff/login" element={<Navigate to="/partner/login" replace />} />
    </>
  );
}
